module.exports = __webpack_public_path__ + "static/4-02af29d2572a1c75a8958cc52862b9b2.jpg";